import React from "react";

// OTP Group logo lockup.
// variant="dark"  -> for LIGHT backgrounds (navy badge + navy wordmark)
// variant="light" -> for DARK/navy backgrounds (white badge + white/steel wordmark)
export const Logo = ({ variant = "dark", showWordmark = true, size = 40, className = "" }) => {
  const isLight = variant === "light";

  const badgeFill = isLight ? "#FFFFFF" : "#0F2A4A";
  const barShort = isLight ? "#0F2A4A" : "#FFFFFF";
  const barTall = "#5C7284"; // steel accent (visible on both badges)

  const otpColor = isLight ? "#FFFFFF" : "#0F2A4A";
  const groupColor = isLight ? "#8FA6B8" : "#5C7284";

  return (
    <span className={`inline-flex items-center gap-3 ${className}`} data-testid="otp-logo">
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <rect width="48" height="48" rx="12" fill={badgeFill} />
        <rect x="12" y="24" width="6" height="12" rx="3" fill={barShort} />
        <rect x="21" y="18" width="6" height="18" rx="3" fill={barShort} />
        <rect x="30" y="10" width="6" height="26" rx="3" fill={barTall} />
      </svg>
      {showWordmark && (
        <span
          className="tracking-wordmark font-medium text-[1.05rem] leading-none select-none"
          style={{ color: otpColor }}
        >
          OTP&nbsp;<span style={{ color: groupColor }}>GROUP</span>
        </span>
      )}
    </span>
  );
};

export default Logo;
